



















































































































import { apiCommodityDeliveryCommodityStoreDetail } from '@/api'
import { AsyncReturnType } from 'vtils/types'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import {
  defineClassComponent,
  useApiPlus,
  useHandler,
  useQuery,
} from '@/hooks'
import { navigateTo } from '@/router'
import { openMap, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '店铺详情页',
        }))
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        martId: string
      }>({
        martId: {
          alias: 'id',
        },
      })

      apiData = useApiPlus({
        martData: async () => {
          const { longitude, latitude } = await dcb
            .getLocation()
            .catch(() => ({} as AsyncReturnType<typeof dcb.getLocation>))
          return apiCommodityDeliveryCommodityStoreDetail({
            storeId: this.query.martId,
            longitude: longitude as any,
            latitude: latitude as any,
          })
        },
      })

      martData = computed(() => this.apiData.data.martData)

      handleServiceClick = useHandler<
        '导航' | '联系商家' | '商家资质' | '门店照片'
      >({
        导航: () => {
          openMap({
            longitude: +this.martData.value.longitude!,
            latitude: +this.martData.value.latitude!,
          })
        },
        联系商家: () => {
          dcb.makePhoneCall({
            phoneNumber: this.martData.value.storePhone!,
          })
        },
        商家资质: () => {
          navigateTo('MartCert', {
            id: this.query.martId,
          })
        },
        门店照片: () => {
          navigateTo('MartPhoto', {
            id: this.query.martId,
          })
        },
      })
    },
)
